import { IconMinus as TablerIconMinus } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconMinus = /*#__PURE__*/ createOutlineIcon(TablerIconMinus, 'IconMinus');
